import { render } from "./Control1New.vue?vue&type=template&id=783a4602&scoped=true&ts=true&lang=pug"
import script from "./Control1New.vue?vue&type=script&lang=ts"
export * from "./Control1New.vue?vue&type=script&lang=ts"

import "./Control1New.vue?vue&type=style&index=0&id=783a4602&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783a4602"]])

export default __exports__